<script>
import * as PIXI from 'pixi.js';

export default {
	// Gets us the provider property from the parent <pixi-stage> component.
	inject: ['EventBus', 'provider'],

	props: {
		width: {
			type: Number,
			default: 100
		},
		height: {
			type: Number,
			default: 500
		}
	},

	watch: {
		width() {
			this.plane.width = this.width;
		},
		height() {
			this.plane.height = this.height;
		}
	},

	data() {
		return {}
	},

	render: function(h) {
		return h('template', this.$slots.default)
	},

	methods: {
		onPixiReady() {

			this.app = this.provider.app;
			this.stage = this.app.stage;

			const plane = new PIXI.Sprite(PIXI.Texture.WHITE);
			plane.tint = 0x00b300;
			plane.factor = 1;
			plane.anchor.set(0.5);
			plane.position.set(this.provider.width / 2, 0);
			plane.width = this.width;
			plane.height = this.height;
			//plane.skew = new PIXI.Point(-0.08, 0);
			plane.name = 'DragBoundries';
			plane.y = this.provider.height - (565 / 2) - 20;

			Object.defineProperty(this, 'plane', { value: plane, configurable: false });

			this.provider.utilsContainer.addChild(plane);

		},
	},

	beforeDestroy() {

		if (this.trash) {
			this.trash.removeAllListeners();
			this.provider.utilsContainer.removeChild(this.trash);
		}

	},

	mounted() {

		if (this.provider.ready) {
			this.onPixiReady();
		} else {
			this.EventBus.$on('ready', this.onPixiReady);
		}
	}
}
</script>



// WEBPACK FOOTER //
// assets/vue/apps/participate/pixi-boundries.vue